

var n1SectionV2Fn = function (section) {
    section = $(section);
    var trigger = section[0];
    ScrollTrigger.create({
        trigger: trigger,
        start: 'top center',
        toggleActions: 'play none none reverse',
        animation: gsap.from(section.find('.n1-views-v2-item'), {
                y: '20%',
                opacity: 0,
                stagger: 0.1,
                duration: 0.3
            }, 0)
    });
};
var n1SectionV2Init = function () {
    var cardGroupV2 = $('.n1-views-v2-list');
    for (var i = 0; i < cardGroupV2.length; i++) {
        n1SectionV2Fn(cardGroupV2[i]);
    }
};
n1SectionV2Init();




var n1FontFn = function (section) {
    section = $(section);
    var trigger = section[0];
    ScrollTrigger.create({
        trigger: trigger,
        start: 'top center',
        end: 'top top',
        scrub: true,
        animation: gsap.timeline().from(section.find('.n1-views-section-font-icon,.n1-views-section-font-title,.n1-views-section-font-des'), {
                y: '10vw',
                opacity: 0
            }, 0)
    });
};
var n1FontInit = function () {
    var cardGroupV2 = $('.n1-views-section-font');
    console.log(cardGroupV2)
    for (var i = 0; i < cardGroupV2.length; i++) {
        n1FontFn(cardGroupV2[i]);
    }
};
n1FontInit();

var n1SectionV4Fn = function (section) {
    section = $(section);
    var trigger = section[0];
        ScrollTrigger.create({
        trigger: trigger,
        start: 'top center',
        end: 'top top',
        scrub: true,
        animation: gsap.timeline()
        .from(section.find('.n1-views-section-img'), {
            height:0,
            opacity:0,
            delay:.5,
            duration:3
        }, 0)
        .from(section.find('.n1-views-section-cont'), {
            y: '5vh',
            opacity:0,
            delay:2.5
        }, 0)
    });
};
var n1SectionV4Init = function () {
    var x1SectionImgAnmiV5 = $('.n1-views-section-v4');
    for (var i = 0; i < x1SectionImgAnmiV5.length; i++) {
        n1SectionV4Fn(x1SectionImgAnmiV5[i]);
    }
};
n1SectionV4Init();





var n1SectionV5Fn = function (section) {
    section = $(section);
    var clientHeight = document.documentElement.clientHeight;
    var clientWidth = document.documentElement.clientWidth;
    var headerHeight = document.querySelector('header').clientHeight + document.querySelector('aside').clientHeight;
    var trigger = section[0];

    ScrollTrigger.create({
        trigger: trigger,
        start: 'top top',
        end: '+=' + (clientHeight),
        scrub: true,
        pin: true,
        animation: gsap.timeline()
            .to(section.find('.n1-pro'), 
                {
                    y: '0',
                    duration:110,
                    delay:15
                },
            0)

            .to(section.find('.n1-section-cont'), 
                {
                    y: '0',
                    duration:110,
                    delay:15
                },
            0)
            
            
            .from(section.find('.n1-subtitle,.n1-title'), {
                color:"#000",
                duration:40,
                delay:30
            }, 0)


            .to(section.find('.n1-pro-bg'), {
                scale:1,
                duration:100,
                delay:115
            }, 0)
            /*.from(section.find('.n1-pro-img'), {
                y:"10vw",
                scale:.8,
                duration:100,
                delay:115
            }, 0)*/



            .to(section.find('.bg-lays'), {
                delay:230,
                background:"#fff",
                duration:100
            }, 0)
            .to(section.find('.n1-pro-bg-img'), {
                delay:230,
                opacity:0,
                duration:100
            }, 0)
            .to(section.find('.box-img2'), {
                delay:230,
                opacity:1,
                duration:100
            }, 0)
            .to(section.find('.n1-subtitle,.n1-title,.n1-des,.n1-valuetxt,.n1-valuesub'), {
                delay:230,
                color:"#000",
                duration:100
            }, 0)
            .to(section.find('.n1-roundValue'), {
                delay:230,
                width:"100%",
                duration:100
            }, 0)
            .to(section.find('.n1-roundValue'), {
                delay:480
            }, 0)
    });
};
var n1SectionV5Init = function () {
    var x1SectionImgAnmiV5 = $('.n1-views-section-v5');
    for (var i = 0; i < x1SectionImgAnmiV5.length; i++) {
        n1SectionV5Fn(x1SectionImgAnmiV5[i]);
    }
};
n1SectionV5Init();


var n1SectionV6Fn = function (section) {
    section = $(section);
    var clientHeight = document.documentElement.clientHeight;
    var clientWidth = document.documentElement.clientWidth;
    var headerHeight = document.querySelector('header').clientHeight + document.querySelector('aside').clientHeight;
    var trigger = section[0];

    ScrollTrigger.create({
        trigger: trigger,
        start: 'top top',
        end: '+=' + (clientHeight),
        scrub: true,
        pin: true,
        animation: gsap.timeline()
            .to(section.find('.title,.desc'), {
                color:"#fff",
                delay:3
            }, 0)
            .to(section.find('.box-img'), 
            {
                delay:1,
                width: '100vw',
                height: '100vh',
                duration:5
            },
            0)

            

            .to(section.find('.box-img2'), {
                delay: 3,
                opacity:1,
                duration:3
            }, 0)
            .to(section.find('.box-img'), {
                delay: 3,
                opacity:0,
                duration:3
            }, 0)
            .to(section.find('.bg-lays'), {
                delay: 3,
                background:"#000",
                duration:3
            }, 0)
            .to(section.find('.bg-lays'), {
                delay:20,
                background:"#000"
            }, 0)
    });

};
var n1SectionV6Init = function () {
    var x1SectionImgAnmiV5 = $('.n1-views-section-v6');
    for (var i = 0; i < x1SectionImgAnmiV5.length; i++) {
        n1SectionV6Fn(x1SectionImgAnmiV5[i]);
    }
};
n1SectionV6Init();



var n1SectionV7Fn = function (section) {
    section = $(section);
    var clientHeight = document.documentElement.clientHeight;
    var trigger = section[0];

    ScrollTrigger.create({
        trigger: trigger,
        start: 'top top',
        end: '+=' + (clientHeight),
        scrub: true,
        pin: true,
        animation: gsap.timeline()
        .from(section.find('.menu-list'), {
            y: '10vh',
            opacity:0,
            delay:6
        }, 0)
        .from(section.find('.cont'), {
            y: '10vh',
            opacity:0
        }, 0)

           .fromTo(section.find('.pro'), {
                x:'-50%',
                y:'-50%',
                scale: 1,
                duration:15,
                delay:4
            }, {
                x:'-50%',
                y:'-50%',
                scale: 2.7,
                duration:15,
                delay:4
            }, 0)

        .fromTo(section.find('.pimg'), {
            opacity: 1,
            duration:5,
            delay:20
        }, {
            opacity: 0,
            duration:5,
            delay:20
        }, 0)
        .to(section.find('.pimg2'), {
            opacity:1,
            duration:5,
            delay:20
        }, 0)
        .to(section.find('.bg-box'), {
            background:"#000",
            duration:5,
            delay:20
        }, 0)
        
        .to(section.find('.cont'), {
            color:"#fff",
            duration:5,
            delay:20
        }, 0)
        .to(section.find('.cont'), {
            color:"#fff",
            delay:40
        }, 0)
    });
};
var n1SectionV7Init = function () {
    var x1SectionImgAnmiV5 = $('.n1-views-section-v7');
    for (var i = 0; i < x1SectionImgAnmiV5.length; i++) {
        n1SectionV7Fn(x1SectionImgAnmiV5[i]);
    }
};
n1SectionV7Init();


var n1SectionV8Fn = function (section) {
    section = $(section);
    var clientHeight = document.documentElement.clientHeight;
    var clientWidth = document.documentElement.clientWidth;
    var headerHeight = document.querySelector('header').clientHeight + document.querySelector('aside').clientHeight;
    var trigger = section[0];

    ScrollTrigger.create({
        trigger: trigger,
        start: 'top top',
        end: '+=' + (clientHeight ),
        scrub: true,
        pin: true,
        animation: gsap.timeline()
        .to(section.find('.n-bg'), {
            opacity:.2
        }, 0)
        .from(section.find('.cont-title'), {
            y: '10vh',
            opacity:0,
            delay:1
        }, 0)
        .from(section.find('.cont-des'), {
            y: '10vh',
            opacity:0,
            delay:1.2
        }, 0)
        .to(section.find('.cont'), {
            color:"#fff",
            delay:5
        }, 0)
        .to(section.find('.menu-list'), {
            opacity:1,
            delay:5
        }, 0)


        .from(section.find('.overlaybox'), {
            opacity:0,
            delay:1.8
        }, 0)
           .fromTo(section.find('.overlaybox'), {
                delay:5
            }, {
                width:"800vw",
                height:"800vw",
                duration:5,
                delay:5
            }, 0)
    });
};
var n1SectionV8Init = function () {
    var x1SectionImgAnmiV5 = $('.n1-views-section-v8');
    for (var i = 0; i < x1SectionImgAnmiV5.length; i++) {
        n1SectionV8Fn(x1SectionImgAnmiV5[i]);
    }
};
n1SectionV8Init();




var n1SectionV10Fn = function (section) {
    section = $(section);
    var trigger = section[0];

    ScrollTrigger.create({
        trigger: trigger,
        start: 'top bottom',
        end: 'top top',
        scrub: true,
        animation: gsap.timeline()
            .from(section.find('.ani1'), {
                y: '10vw',
                opacity:.5
            }, 0)
            .from(section.find('.ani2'), {
                y: '10vw',
                opacity:0.5,
                delay:0.1
            }, 0)
            .from(section.find('.ani3'), {
                y: '10vw',
                opacity:0.5,
                delay:.2
            }, 0)
            .from(section.find('.ani4'), {
                y: '10vw',
                opacity:0.5,
                delay:.5
            }, 0)
    });
};
var n1SectionV10Init = function () {
    var x1SectionImgAnmiV5 = $('.n1-views-section-v10 .sectionBox');
    for (var i = 0; i < x1SectionImgAnmiV5.length; i++) {
        n1SectionV10Fn(x1SectionImgAnmiV5[i]);
    }
};
n1SectionV10Init();


var n1SectionV11Fn = function (section) {
    section = $(section);
    var clientHeight = document.documentElement.clientHeight;
    var clientWidth = document.documentElement.clientWidth;
    var headerHeight = document.querySelector('header').clientHeight + document.querySelector('aside').clientHeight;
    var trigger = section[0];

    ScrollTrigger.create({
        trigger: trigger,
        start: 'top top',
        end: '+=' + (clientHeight ),
        scrub: true,
        pin: true,
        animation: gsap.timeline()
            
            
            .from(section.find('.lays'), {
                duration:3,
                opacity:0
            }, 0)
            .from(section.find('.title1'), {
                duration:3,
                y:'10vh',
                opacity:0
            }, 0)
            .from(section.find('.content1'), {
                duration:3,
                y:'10vh',
                opacity:0,
                delay:2
            }, 0)
            .to(section.find('.title1'), {
                duration:3,
                y:'10vh',
                opacity:0,
                delay:12
            }, 0)
            .to(section.find('.content1'), {
                duration:3,
                y:'10vh',
                opacity:0,
                delay:14
            }, 0)
            .from(section.find('.content1'), {
                duration:3,
                delay:17
            }, 0)

            .from(section.find('.title2'), {
                duration:3,
                y:'10vh',
                opacity:0,
                delay:20
            }, 0)
            .from(section.find('.content2'), {
                duration:3,
                y:'10vh',
                opacity:0,
                delay:22
            }, 0)
            .from(section.find('.content2'), {
                duration:3,
                delay:32
            }, 0)
    });
};
var n1SectionV11Init = function () {
    var x1SectionImgAnmiV5 = $('.n1-views-section-v11');
    for (var i = 0; i < x1SectionImgAnmiV5.length; i++) {
        n1SectionV11Fn(x1SectionImgAnmiV5[i]);
    }
};
n1SectionV11Init();


var n1SectionV12Fn = function (section) {
    section = $(section);
    var clientHeight = document.documentElement.clientHeight;
    var clientWidth = document.documentElement.clientWidth;
    var headerHeight = document.querySelector('header').clientHeight + document.querySelector('aside').clientHeight;
    var trigger = section[0];

    ScrollTrigger.create({
        trigger: trigger,
        start: 'top center',
        end: 'top top',
        scrub: true,
        animation: gsap.timeline()
            .from(section.find('h4'), {
                y: '20%',
                opacity:0
            }, 0)
            .from(section.find('.des'), {
                duration:1,
                y: '20%',
                opacity:0
            }, 0)
    });
};
var n1SectionV12Init = function () {
    var x1SectionImgAnmiV5 = $('.n1-views-section-v12 .top-box');
    for (var i = 0; i < x1SectionImgAnmiV5.length; i++) {
        n1SectionV12Fn(x1SectionImgAnmiV5[i]);
    }
};
n1SectionV12Init();

var n1SectionV13Fn = function (section) {
    section = $(section);
    var clientHeight = document.documentElement.clientHeight;
    var clientWidth = document.documentElement.clientWidth;
    var headerHeight = document.querySelector('header').clientHeight + document.querySelector('aside').clientHeight;
    var trigger = section[0];

    ScrollTrigger.create({
        trigger: trigger,
        start: 'top center',
        end: 'top top',
        scrub: true,
        animation: gsap.timeline()
            .from(section.find('h4'), {
                y: '10vw',
                opacity:0
            }, 0)
            .from(section.find('.tag'), {
                duration:1,
                y: '10vw',
                opacity:0
            }, 0)
            .from(section.find('.des'), {
                duration: 2,
                y: '10vw',
                opacity:0
            }, 0)
    });
};
var n1SectionV13Init = function () {
    var x1SectionImgAnmiV5 = $('.n1-views-section-v13 .contentBox');
    for (var i = 0; i < x1SectionImgAnmiV5.length; i++) {
        n1SectionV13Fn(x1SectionImgAnmiV5[i]);
    }
};
n1SectionV13Init();




$(".accordion-list li").mouseenter(
    function(){
        $(".accordion-list li").stop().removeClass("cut").css({width:'18.22vw'});
        $(this).stop().addClass("cut").animate({width:"30.72917vw"},200);
    }
)


$(".n1-views-section-v7 .menu-list li").click(function(){
    var $index=$(this).index();
    console.log($index)
    $(".n1-views-section-v7 .menu-list li").removeClass("cut").eq($index).addClass("cut");
    $(".n1-views-section-v7 .pro img").hide().eq($index).show();
})

$(".n1-views-section-v8 .menu-list li").click(function(){
    var $index=$(this).index();
    console.log($index)
    $(".n1-views-section-v8 .menu-list li").removeClass("cut").eq($index).addClass("cut");
    $(".n1-views-section-v8 .pro-bg img").hide().eq($index).show();
})
